import { motion } from "framer-motion";
import { MANIFESTO, IMAGES } from "@/data/salon";

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.12 } }),
};

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-24 sm:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-pink">The Ethos</span>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-ink">
              Beauty, written in <span className="italic text-pink">three chapters.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-muted font-light leading-relaxed">
            Fabrowz is not a salon of shortcuts. It is a studio built on philosophy — where every treatment follows a considered, repeatable ritual.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {MANIFESTO.map((m, i) => (
            <motion.article
              key={m.n}
              custom={i}
              variants={fade}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              whileHover={{ y: -6 }}
              data-testid={`manifesto-chapter-${m.n}`}
              className="group relative rounded-2xl border border-pink/25 bg-surface p-8 transition-shadow hover:shadow-xl"
            >
              <span className="font-mono text-sm text-pink">{m.n}</span>
              <div className="mt-6 h-px w-full bg-pink/20 group-hover:bg-pink/50 transition-colors" />
              <h3 className="mt-6 font-serif text-2xl text-ink">{m.title}</h3>
              <p className="mt-4 text-sm text-muted leading-relaxed font-light">{m.body}</p>
            </motion.article>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="mt-16 relative h-[45vh] overflow-hidden rounded-3xl border border-pink/20"
        >
          <img src={IMAGES.interior} alt="Fabrowz studio" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-ink/25" />
          <div className="absolute bottom-8 left-8 right-8">
            <p className="font-serif italic text-2xl sm:text-3xl text-cream max-w-xl">"A sanctuary designed for slowness, precision and the quiet confidence of feeling entirely yourself."</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
